import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConnectedRouter } from "connected-react-router";
import createStore from "./store";
import App from "./components/Pages/App";
import * as serviceWorker from "./serviceWorker";
import { builderIsEnabled } from "./utils/general";
import { initTelemetry } from "./utils/telemetry";

// Global styles
import "./scss/_global.scss";
import "./styles/globals.css";

// Create a store and get back itself and its history object
const { store, history, persistor } = createStore();

// Set up telemetry tools
initTelemetry();

// Initialize Builder.io
if (builderIsEnabled()) {
  const { builder } = require("@builder.io/react");
  builder.init(process.env.REACT_APP_BUILDER_IO_PUBLIC_API_KEY);
}

// Running locally, we should run on a <ConnectedRouter /> rather than on a <StaticRouter /> like on the server
ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register()
serviceWorker.unregisterAll();
